/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Sort_Discountpercent1Inputs */

const id_search_sort_discountpercent1 = /** @type {(inputs: Search_Sort_Discountpercent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diskon %`)
};

const ms_search_sort_discountpercent1 = /** @type {(inputs: Search_Sort_Discountpercent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diskaun %`)
};

const da_search_sort_discountpercent1 = /** @type {(inputs: Search_Sort_Discountpercent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rabat %`)
};

const de_search_sort_discountpercent1 = /** @type {(inputs: Search_Sort_Discountpercent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rabatt %`)
};

const en_us2_search_sort_discountpercent1 = /** @type {(inputs: Search_Sort_Discountpercent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discount %`)
};

const es_es2_search_sort_discountpercent1 = /** @type {(inputs: Search_Sort_Discountpercent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descuento %`)
};

const es_mx2_search_sort_discountpercent1 = /** @type {(inputs: Search_Sort_Discountpercent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descuento %`)
};

const fil_search_sort_discountpercent1 = /** @type {(inputs: Search_Sort_Discountpercent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diskwento %`)
};

const fr_search_sort_discountpercent1 = /** @type {(inputs: Search_Sort_Discountpercent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réduction %`)
};

const it_search_sort_discountpercent1 = /** @type {(inputs: Search_Sort_Discountpercent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sconto %`)
};

const hu_search_sort_discountpercent1 = /** @type {(inputs: Search_Sort_Discountpercent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kedvezmény %`)
};

const nl_search_sort_discountpercent1 = /** @type {(inputs: Search_Sort_Discountpercent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Korting %`)
};

const no_search_sort_discountpercent1 = /** @type {(inputs: Search_Sort_Discountpercent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rabatt %`)
};

const pl_search_sort_discountpercent1 = /** @type {(inputs: Search_Sort_Discountpercent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rabat %`)
};

const pt_br2_search_sort_discountpercent1 = /** @type {(inputs: Search_Sort_Discountpercent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`% de desconto`)
};

const pt_search_sort_discountpercent1 = /** @type {(inputs: Search_Sort_Discountpercent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desconto %`)
};

const ro_search_sort_discountpercent1 = /** @type {(inputs: Search_Sort_Discountpercent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reducere %`)
};

const fi_search_sort_discountpercent1 = /** @type {(inputs: Search_Sort_Discountpercent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alennus %`)
};

const sv_search_sort_discountpercent1 = /** @type {(inputs: Search_Sort_Discountpercent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rabatt %`)
};

const vi_search_sort_discountpercent1 = /** @type {(inputs: Search_Sort_Discountpercent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giảm %`)
};

const tr_search_sort_discountpercent1 = /** @type {(inputs: Search_Sort_Discountpercent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İndirim %`)
};

const cs_search_sort_discountpercent1 = /** @type {(inputs: Search_Sort_Discountpercent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sleva %`)
};

const bg_search_sort_discountpercent1 = /** @type {(inputs: Search_Sort_Discountpercent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отстъпка %`)
};

const ru_search_sort_discountpercent1 = /** @type {(inputs: Search_Sort_Discountpercent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скидка %`)
};

const uk_search_sort_discountpercent1 = /** @type {(inputs: Search_Sort_Discountpercent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Знижка %`)
};

const ar_search_sort_discountpercent1 = /** @type {(inputs: Search_Sort_Discountpercent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نسبة الخصم`)
};

const hi_search_sort_discountpercent1 = /** @type {(inputs: Search_Sort_Discountpercent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`छूट %`)
};

const th_search_sort_discountpercent1 = /** @type {(inputs: Search_Sort_Discountpercent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ส่วนลด %`)
};

const ja_search_sort_discountpercent1 = /** @type {(inputs: Search_Sort_Discountpercent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`割引率`)
};

const zh_cn2_search_sort_discountpercent1 = /** @type {(inputs: Search_Sort_Discountpercent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`折扣百分比`)
};

const zh_hant1_search_sort_discountpercent1 = /** @type {(inputs: Search_Sort_Discountpercent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`折扣百分比`)
};

const ko_search_sort_discountpercent1 = /** @type {(inputs: Search_Sort_Discountpercent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`할인율`)
};

/**
* | output |
* | --- |
* | "Discount %" |
*
* @param {Search_Sort_Discountpercent1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const search_sort_discountpercent1 = /** @type {((inputs?: Search_Sort_Discountpercent1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Sort_Discountpercent1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_search_sort_discountpercent1(inputs)
	if (locale === "ms") return ms_search_sort_discountpercent1(inputs)
	if (locale === "da") return da_search_sort_discountpercent1(inputs)
	if (locale === "de") return de_search_sort_discountpercent1(inputs)
	if (locale === "en-US") return en_us2_search_sort_discountpercent1(inputs)
	if (locale === "es-ES") return es_es2_search_sort_discountpercent1(inputs)
	if (locale === "es-MX") return es_mx2_search_sort_discountpercent1(inputs)
	if (locale === "fil") return fil_search_sort_discountpercent1(inputs)
	if (locale === "fr") return fr_search_sort_discountpercent1(inputs)
	if (locale === "it") return it_search_sort_discountpercent1(inputs)
	if (locale === "hu") return hu_search_sort_discountpercent1(inputs)
	if (locale === "nl") return nl_search_sort_discountpercent1(inputs)
	if (locale === "no") return no_search_sort_discountpercent1(inputs)
	if (locale === "pl") return pl_search_sort_discountpercent1(inputs)
	if (locale === "pt-BR") return pt_br2_search_sort_discountpercent1(inputs)
	if (locale === "pt") return pt_search_sort_discountpercent1(inputs)
	if (locale === "ro") return ro_search_sort_discountpercent1(inputs)
	if (locale === "fi") return fi_search_sort_discountpercent1(inputs)
	if (locale === "sv") return sv_search_sort_discountpercent1(inputs)
	if (locale === "vi") return vi_search_sort_discountpercent1(inputs)
	if (locale === "tr") return tr_search_sort_discountpercent1(inputs)
	if (locale === "cs") return cs_search_sort_discountpercent1(inputs)
	if (locale === "bg") return bg_search_sort_discountpercent1(inputs)
	if (locale === "ru") return ru_search_sort_discountpercent1(inputs)
	if (locale === "uk") return uk_search_sort_discountpercent1(inputs)
	if (locale === "ar") return ar_search_sort_discountpercent1(inputs)
	if (locale === "hi") return hi_search_sort_discountpercent1(inputs)
	if (locale === "th") return th_search_sort_discountpercent1(inputs)
	if (locale === "ja") return ja_search_sort_discountpercent1(inputs)
	if (locale === "zh-CN") return zh_cn2_search_sort_discountpercent1(inputs)
	if (locale === "zh-Hant") return zh_hant1_search_sort_discountpercent1(inputs)
	return ko_search_sort_discountpercent1(inputs)
});
export { search_sort_discountpercent1 as "search.sort.discountPercent" }